import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import LevelASubCardHeaderText from "../../texts/levelAScreen/LevelASubCardHeaderText";
import LevelAExampleAnswerText from "../../texts/levelAScreen/LevelAExampleAnswerText";

export default function LevelAExampleAnswer({answer, isTextCentered, isBrevetDisplay}) {
    // Used in LevelAExample to display LevelA Knowledge example answer

    // BUILD
    return (
        <div className={"w-2/5 bg-primaryDark7/30 border-[1px] border-greyLight1 flex flex-col justify-start items-start px-[16px] pt-[12px] rounded-[12px]"}>
            <div className={"w-full flex flex-col justify-start items-center"}>
                <LevelASubCardHeaderText text={"Solution"} />
                <SystemCustomDivider color={"bg-greyLight5"} extraClass={"mt-[12px]"} />
            </div>
            <div className={`grow w-full flex ${isTextCentered ? "h-full flex-col justify-center" : "justify-start"} items-center`}>
                <LevelAExampleAnswerText answer={answer}
                                         isBrevetDisplay={isBrevetDisplay} />
            </div>
        </div>
    );
}